/**
 * Resolve the weight unit the current organization uses for W&B display
 * (e.g. "lb", "kg"). Reads `state.organization.organizationSettings.weightUnit`
 * when present and falls back to "lb".
 *
 * Backend gap (2026-04-22): `weightUnit` is currently stored per-aircraft in
 * `weightAndBalance.weightUnit` but no API response DTO exposes it. Until a
 * follow-up backend ticket lands (add `weightUnit` to `organizationSettings`
 * or to the events payload), this selector returns the hard-coded fallback
 * for every org; once the field is populated, the selector will pick it up
 * transparently.
 */
export function selectWeightUnit(state) {
	const raw = state?.organization?.organizationSettings?.weightUnit;
	if (typeof raw === 'string' && raw.trim()) return raw.trim();
	return 'lb';
}
